import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTenderGridLayout extends Layout {
	buttonSuggestedPricingTest: Button;
	sourceEdiStop: DataSource;
	sourceLoadTenderExpress: DataSource;
	tableLtx: Table;
}
